import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { apiGetMyTickets } from "../../api/ticketingApi";

// Embedded account view (rendered inside the My-Profile layout, so no Navbar
// of its own). Lists the customer's issued tickets; tapping one opens its QR.
const statusColor = (s) =>
  s === "USED" ? "#6b7280" : s === "VOID" || s === "REFUNDED" ? "#dc2626" : "#4d7a10";

const UserTickets = () => {
  const history = useHistory();
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    apiGetMyTickets()
      .then((d) => { if (alive) { setTickets(d.tickets || []); setLoading(false); } })
      .catch(() => { if (alive) { setError("We couldn't load your tickets."); setLoading(false); } });
    return () => { alive = false; };
  }, []);

  return (
    <Wrap>
      <h2>My Tickets</h2>
      <Sub>Your event tickets. Tap one to show its QR at the entrance.</Sub>
      {loading && <Muted>Loading…</Muted>}
      {!loading && error && <Muted>{error}</Muted>}
      {!loading && !error && tickets.length === 0 && (
        <Empty>
          <div style={{ fontSize: 34 }}>🎟️</div>
          <div style={{ fontWeight: 700, color: "#1f2937", marginTop: 8 }}>No tickets yet</div>
          <div>When you buy an event ticket, it appears here with a scannable QR code.</div>
        </Empty>
      )}
      <List>
        {tickets.map((t) => (
          <Row key={t._id} onClick={() => history.push(`/ticket/${t._id}`)}>
            <div>
              <TName>{t.ticketTypeName || "Ticket"}{t.seatLabel ? ` · Seat ${t.seatLabel}` : ""}</TName>
              <TMeta>{t.serial}{t.price ? ` · ${t.currency || "UGX"} ${Number(t.price).toLocaleString()}` : ""}</TMeta>
            </div>
            <Right>
              <Status style={{ color: statusColor(t.status) }}>{t.status}</Status>
              <View>View QR ›</View>
            </Right>
          </Row>
        ))}
      </List>
    </Wrap>
  );
};

const Wrap = styled.div`
  padding: 8px 4px 24px;
  h2 { font-size: 22px; font-weight: 800; color: #1f2937; margin: 0 0 4px; }
`;
const Sub = styled.div`color:#6b7280;font-size:13.5px;margin-bottom:18px;`;
const Muted = styled.div`color:#6b7280;padding:16px 0;`;
const Empty = styled.div`text-align:center;color:#6b7280;font-size:13.5px;background:#fafafa;border:1px dashed #e5e7eb;border-radius:14px;padding:36px 20px;`;
const List = styled.div`display:flex;flex-direction:column;gap:10px;`;
const Row = styled.div`
  display:flex;align-items:center;justify-content:space-between;
  background:#fff;border:1px solid #eef0f2;border-radius:12px;padding:15px 18px;cursor:pointer;
  transition:box-shadow .2s ease,border-color .2s ease;
  &:hover{box-shadow:0 6px 16px rgba(0,0,0,.08);border-color:#d8e6c2;}
`;
const TName = styled.div`font-weight:700;color:#1f2937;`;
const TMeta = styled.div`font-size:12.5px;color:#6b7280;margin-top:4px;`;
const Right = styled.div`display:flex;align-items:center;gap:14px;`;
const Status = styled.div`font-size:12px;font-weight:800;letter-spacing:.4px;`;
const View = styled.div`font-size:12.5px;font-weight:700;color:#4d7a10;white-space:nowrap;`;

export default UserTickets;
